export const hardRedirect = (url: string) => {
  window.location.href = url;
};
